module.exports = __webpack_public_path__ + "img/job_booking10.34a8668a.png";